module.exports = __webpack_public_path__ + "img/icon-generic-generic5.aeca1151.svg";